import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Select } from '@/components/form/Select';
import { required } from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

import { ScFieldExpiryDateRow } from './styled';

export const FieldSelect: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Select]
> = ({ fieldName, placeholder, label, options, activeThemeMode }) => {
  const optionsFormatted = options.map(({ label, value }) => ({
    name: label,
    value,
  }));

  return (
    <FormGroup mode={activeThemeMode} title={label || undefined}>
      <ScFieldExpiryDateRow $list>
        <Select
          mode={activeThemeMode}
          name={fieldName}
          options={optionsFormatted}
          placeholder={placeholder || label || fieldName}
          validate={required}
        />
      </ScFieldExpiryDateRow>
    </FormGroup>
  );
};
